import BasicEditor from './BasicEditor.react';
import PropTypes from 'prop-types';

export class EditorWithSubmit extends BasicEditor {
	static propTypes = {
		submit: PropTypes.func,
	};

	submitForm(data) {
		return this.props.submit(data);
	}
}
